export const colors = {
  primary: {
    default: "#060607",
    hover: "#414141",
  },
  bg: {
    white: {
      main: "#FFFFFF",
      sub: "#FAFBFC",
    },
    black: {
      main: "#060607",
      sub: "#141417",
      light: "#313335",
    },
  },
  text: {
    dark: {
      title: "#060607",
      body: "#4C5359",
      sub: "#B9C0C9",
    },
    light: {
      title: "#FFFFFF",
      body: "#D7DBE0",
    },
  },
};
